import type { App } from 'vue'
import { DateTime, Interval } from 'luxon'

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $luxon: {
      DateTime: typeof DateTime
      Interval: typeof Interval
    }
  }
}

export function register(app: App) {
  app.config.globalProperties.$luxon = {
    DateTime,
    Interval,
  }
}
